import { useState } from 'react';
import './index.css';

function App() {
  const [taches, setTaches] = useState([]);
  const [nouvelleTache1, setNouvelleTache1] = useState('');
  const [nouvelleTache2, setNouvelleTache2] = useState('');
  const [nouvelleTache3, setNouvelleTache3] = useState('');
  const [nouvelleTache, setNouvelleTache] = useState('');
  const [pageOnboarding, setPageOnboarding] = useState(0);
  const [reponses, setReponses] = useState({
    nom: '',
    objectif: '',
    experience: 'debutant'
  });
  const [onboardingTermine, setOnboardingTermine] = useState(false);
  const [categorie, setCategorie] = useState('travail');
  const [filtreCategorie, setFiltreCategorie] = useState('toutes');
  const [filtre, setFiltre] = useState('toutes');

  const categories = [
    { id: 'travail', nom: '💼 Travail', couleur: '#3b82f6' },
    { id: 'personnel', nom: '🏠 Personnel', couleur: '#10b981' },
    { id: 'urgent', nom: '⚡ Urgent', couleur: '#ef4444' }
  ];

  const ajouterTache = (texte, resetFunction) => {
    if (texte && texte.trim() !== '') {
      const tache = {
        id: Date.now(),
        texte: texte,
        terminee: false,
        categorie: categorie
      };
      setTaches([...taches, tache]);
      if (resetFunction) {
        resetFunction('');
      }
    }
  };

  const ajouterTacheSimple = () => {
    if (nouvelleTache.trim() !== '') {
      const tache = {
        id: Date.now(),
        texte: nouvelleTache,
        terminee: false,
        categorie: categorie
      };
      setTaches([...taches, tache]);
      setNouvelleTache('');
    }
  };

  const toggleTache = (id) => {
    setTaches(taches.map(tache =>
      tache.id === id ? { ...tache, terminee: !tache.terminee } : tache
    ));
  };

  const supprimerTache = (id) => {
    setTaches(taches.filter(tache => tache.id !== id));
  };

  const supprimerTachesTerminees = () => {
    setTaches(taches.filter(tache => !tache.terminee));
  };

  const changerReponse = (champ, valeur) => {
    setReponses({ ...reponses, [champ]: valeur });
  };

  const pageSuivante = () => {
    setPageOnboarding(pageOnboarding + 1);
  };

  const pagePrecedente = () => {
    setPageOnboarding(pageOnboarding - 1);
  };

  const terminerOnboarding = () => {
    setOnboardingTermine(true);
  };

  const tachesFiltrees = taches.filter(tache => {
    const filtreEtat = filtre === 'toutes' ||
      (filtre === 'actives' && !tache.terminee) ||
      (filtre === 'terminees' && tache.terminee);
    
    const filtreCat = filtreCategorie === 'toutes' || tache.categorie === filtreCategorie;
    
    return filtreEtat && filtreCat;
  });

  if (!onboardingTermine) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-2xl w-full">
          {/* PAGE 1 : PREMIÈRE VERSION - Mes objectifs du jour */}
          {pageOnboarding === 0 && (
            <div>
              <h1 className="text-3xl font-bold text-center mb-8">📝 Mes objectifs du jour</h1>
              <div className="space-y-4 mb-8">
                <div className="flex gap-3">
                  <input
                    type="text"
                    value={nouvelleTache1}
                    onChange={(e) => setNouvelleTache1(e.target.value)}
                    placeholder="Quelle est votre premier objectif ?"
                    className="flex-1 p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                  />
                  <button
                    onClick={() => ajouterTache(nouvelleTache1, setNouvelleTache1)}
                    className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition font-medium"
                  >
                    Ajouter
                  </button>
                </div>
                <div className="flex gap-3">
                  <input
                    type="text"
                    value={nouvelleTache2}
                    onChange={(e) => setNouvelleTache2(e.target.value)}
                    placeholder="Quelle est votre second objectif ?"
                    className="flex-1 p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                  />
                  <button
                    onClick={() => ajouterTache(nouvelleTache2, setNouvelleTache2)}
                    className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition font-medium"
                  >
                    Ajouter
                  </button>
                </div>
                <div className="flex gap-3">
                  <input
                    type="text"
                    value={nouvelleTache3}
                    onChange={(e) => setNouvelleTache3(e.target.value)}
                    placeholder="Quelle est votre troisieme objectif ?"
                    className="flex-1 p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                  />
                  <button
                    onClick={() => ajouterTache(nouvelleTache3, setNouvelleTache3)}
                    className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition font-medium"
                  >
                    Ajouter
                  </button>
                </div>
              </div>

              <div className="mb-6">
                {taches.length === 0 ? (
                  <p className="text-center text-gray-500 py-8">Aucun objectif pour le moment. Ajoutez-en une !</p>
                ) : (
                  <div className="space-y-2">
                    {taches.map(tache => (
                      <div
                        key={tache.id}
                        className={`flex items-center justify-between p-4 rounded-lg border-2 transition ${
                          tache.terminee ? 'bg-gray-100 border-gray-300' : 'bg-white border-gray-200'
                        }`}
                      >
                        <span
                          onClick={() => toggleTache(tache.id)}
                          className={`flex-1 cursor-pointer ${tache.terminee ? 'line-through text-gray-500' : ''}`}
                        >
                          {tache.texte}
                        </span>
                        <button
                          onClick={() => supprimerTache(tache.id)}
                          className="text-2xl hover:scale-110 transition"
                        >
                          🗑️
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {taches.length > 0 && (
                <div className="bg-blue-50 p-4 rounded-lg text-center mb-6">
                  <p className="text-gray-700">
                    Total: {taches.length} | Terminées: {taches.filter(t => t.terminee).length} | Restantes: {taches.filter(t => !t.terminee).length}
                  </p>
                </div>
              )}

              <button
                onClick={pageSuivante}
                className="w-full bg-green-500 text-white py-3 rounded-lg hover:bg-green-600 transition font-medium"
              >
                Continuer →
              </button>
            </div>
          )}

          {/* PAGE 2 : QUESTIONNAIRE - NOM */}
          {pageOnboarding === 1 && (
            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Comment vous appelez-vous ?</h2>
              <input
                type="text"
                value={reponses.nom}
                onChange={(e) => changerReponse('nom', e.target.value)}
                placeholder="Votre nom..."
                className="w-full p-3 border-2 border-gray-300 rounded-lg mb-8 focus:border-blue-500 focus:outline-none"
              />
              <div className="flex justify-center gap-2 mb-8">
                <span className="text-gray-300 text-2xl">○</span>
                <span className="text-blue-500 text-2xl">●</span>
                <span className="text-gray-300 text-2xl">○</span>
              </div>
              <div className="flex gap-3">
                <button
                  className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300 transition font-medium"
                  onClick={pagePrecedente}
                >
                  Retour
                </button>
                <button
                  className="flex-1 bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 transition font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={pageSuivante}
                  disabled={!reponses.nom.trim()}
                >
                  Suivant
                </button>
              </div>
            </div>
          )}

          {/* PAGE 3 : QUESTIONNAIRE - OBJECTIF ET EXPÉRIENCE */}
          {pageOnboarding === 2 && (
            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Dernières questions</h2>
              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2">Quel est votre objectif principal ?</label>
                <input
                  type="text"
                  value={reponses.objectif}
                  onChange={(e) => changerReponse('objectif', e.target.value)}
                  placeholder="Ex: Organiser mon travail..."
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                />
              </div>
              <div className="mb-8">
                <label className="block text-gray-700 font-medium mb-2">Votre niveau avec les todo lists :</label>
                <select
                  value={reponses.experience}
                  onChange={(e) => changerReponse('experience', e.target.value)}
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                >
                  <option value="debutant">Débutant</option>
                  <option value="intermediaire">Intermédiaire</option>
                  <option value="expert">Expert</option>
                </select>
              </div>
              <div className="flex justify-center gap-2 mb-8">
                <span className="text-gray-300 text-2xl">○</span>
                <span className="text-gray-300 text-2xl">○</span>
                <span className="text-blue-500 text-2xl">●</span>
              </div>
              <div className="flex gap-3">
                <button
                  className
                  onClick={pagePrecedente}
                >
                  Retour
                </button>
                <button
                  className="flex-1 bg-green-500 text-white py-3 rounded-lg hover:bg-green-600 transition font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={terminerOnboarding}
                  disabled={!reponses.objectif.trim()}
                >
                  Terminer
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  // ========== AFFICHAGE : APPLICATION PRINCIPALE ==========
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 min-h-[90vh]">
        {/* EN-TÊTE PERSONNALISÉE */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">📝 Todo List de {reponses.nom}</h1>
          <p className="text-gray-600 mt-2">Objectif : {reponses.objectif}</p>
        </div>

        {/* SÉLECTEUR DE CATÉGORIE */}
        <div className="mb-6">
          <label className="block text-gray-700 font-medium mb-3">Catégorie :</label>
          <div className="flex gap-3 flex-wrap">
            {categories.map(cat => (
              <button
                key={cat.id}
                onClick={() => setCategorie(cat.id)}
                className={`px-4 py-2 rounded-lg border-2 font-medium transition-colors ${cat.id}`}
                style={{
                  borderColor: cat.couleur,
                  backgroundColor: categorie === cat.id ? cat.couleur : '#ffffff',
                  color: categorie === cat.id ? '#ffffff' : cat.couleur
                }}

              >
                {cat.nom}
              </button>
            ))}
          </div>
        </div>

        {/* ZONE D'AJOUT DE TÂCHES */}
        <div className="flex gap-3 mb-6">
          <input
            type="text"
            value={nouvelleTache}
            onChange={(e) => setNouvelleTache(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && ajouterTacheSimple()}
            placeholder="Nouvelle tâche..."
            className="flex-1 p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
          />
          <button
            onClick={ajouterTacheSimple}
            className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition font-medium"
          >
            Ajouter
          </button>
        </div>

        {/* FILTRES PAR CATÉGORIE */}
        <div className="mb-4 flex items-center gap-3">
          <span className="text-gray-700 font-medium">Filtrer par catégorie :</span>
          <select
            value={filtreCategorie}
            onChange={(e) => setFiltreCategorie(e.target.value)}
            className="p-2 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
          >
            <option value="toutes">Toutes les catégories</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>
                {cat.nom}
              </option>
            ))}
          </select>
        </div>

        {/* FILTRES PAR ÉTAT */}
        <div className="flex gap-3 mb-6 flex-wrap">
          <button
            onClick={() => setFiltre('toutes')}
            className={`px-4 py-2 rounded-lg transition font-medium ${
              filtre === 'toutes'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            Toutes ({taches.length})
          </button>
          <button
            onClick={() => setFiltre('actives')}
            className={`px-4 py-2 rounded-lg transition font-medium ${
              filtre === 'actives'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            Actives ({taches.filter(t => !t.terminee).length})
          </button>
          <button
            onClick={() => setFiltre('terminees')}
            className={`px-4 py-2 rounded-lg transition font-medium ${
              filtre === 'terminees'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            Terminées ({taches.filter(t => t.terminee).length})
          </button>
        </div>

        {/* LISTE DES TÂCHES */}
        <div className="space-y-3 mb-6">
          {tachesFiltrees.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-xl text-gray-500 mb-2">
                📋 Aucune tâche {filtre !== 'toutes' ? filtre : ''}
              </p>
              <p className="text-sm text-gray-400">Ajoutez votre première tâche !</p>
            </div>
          ) : (
            tachesFiltrees.map(tache => {
              const cat = categories.find(c => c.id === tache.categorie);
              return (
                <div
                  key={tache.id}
                  className={`flex items-center justify-between p-4 rounded-lg border-2 transition ${
                    tache.terminee
                      ? 'bg-gray-50 border-gray-300 opacity-60'
                      : 'bg-white border-gray-200 hover:border-blue-300'
                  }`}
                >
                  <span
                    onClick={() => toggleTache(tache.id)}
                    className="flex-1 cursor-pointer flex items-center gap-3"
                  >
                    <span
                      className="px-2 py-1 rounded text-xs text-white font-medium"
                      style={{ backgroundColor: cat?.couleur }}
                    >
                      {cat?.nom}
                    </span>
                    <span className={tache.terminee ? 'line-through' : ''}>
                      {tache.terminee ? '✅' : '⭕'} {tache.texte}
                    </span>
                  </span>
                  <button
                    onClick={() => supprimerTache(tache.id)}
                    className="text-red-500 hover:text-red-700 text-xl font-bold ml-4"
                  >
                    ✕
                  </button>
                </div>
              );
            })
          )}
        </div>

        {/* BOUTON NETTOYAGE */}
        {taches.some(t => t.terminee) && (
          <div className="mb-6">
            <button
              onClick={supprimerTachesTerminees}
              className="w-full bg-red-500 text-white py-3 rounded-lg hover:bg-red-600 transition font-medium"
            >
              🧹 Supprimer les tâches terminées
            </button>
          </div>
        )}

        {/* STATISTIQUES */}
        {taches.length > 0 && (
          <div className="text-center text-gray-600 pt-4 border-t-2 border-gray-200">
            <p>
              Total: {taches.length} | Actives: {taches.filter(t => !t.terminee).length} | Terminées: {taches.filter(t => t.terminee).length}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;